// store/apis.ts
import { apiFavorites } from '../entities/Favorites/api/apiFavoritesSlice'
import { cartApi } from '../entities/Order/api/apiCartSlice'
import { categoriesApi } from '../entities/Categories/api/supplier/apiCategoriesSlice'
import { customerApi } from '../entities/Customer/api/apiCustomerSlice'
import { customerInfoApi } from '../entities/Customer/api/Informations/apiCustomerInfo'
import { productApi } from '../entities/ProductDetails/api/suppliers/apiProductSlice'
import { orderApi } from '../entities/Order/api/api2/apiOrderSlice'
import { categoryApiTree } from './global/categoriesTree/apiCategoriesTree'
import { apiProductSlice } from 'features/Home/api/apiProductSliceHome'

export const apis = [
  cartApi,
  categoriesApi,
  customerApi,
  productApi,
  customerInfoApi,
  apiFavorites,
  orderApi,
  categoryApiTree,
  apiProductSlice,
]
